import Request from './request';

async function save(data) {
    return Request('post', "api/hf-interface/add-user", data);
}

//汇付提现
async function hfCash(data) {
  return Request('post', "api/hf-interface/cash", data);
}

//汇付余额查询
async function hfWithdraw(number) {
  return Request('get', "api/hf-interface/withdraw?account_number="+number);
}

// 汇付账户银行卡查询
async function queryCard(number) {
  return Request('post', "api/hf-interface/query-card?account_number="+number);
}

// 汇付省数据查询
async function hfProvince() {
  return Request('get', "api/hf-interface/get-hf-province");
}

//汇付城市数据查询
async function hfCity(code) {
  return Request('get', "api/hf-interface/get-hf-city?province_code="+code);
}

//绑定汇付银行卡
async function bindCard(data) {
  return Request('post', "api/hf-interface/bind-card",data);
}
export default {
  save,
  hfCash,
  hfWithdraw,
  queryCard,
  hfProvince,
  hfCity,
  bindCard,
};